import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, ArrowUpRight } from "lucide-react";
import { PRIMARY_SERVICES } from "@/lib/services";

export default function HomeServicesStrip() {
    return (
        <section data-testid="home-services" className="bg-[#0a0d18] text-white">
            <div className="max-w-[1440px] mx-auto px-6 md:px-10 py-16 md:py-20">
                <div className="flex items-end justify-between flex-wrap gap-6 mb-10">
                    <div>
                        <div className="text-[10px] uppercase tracking-[0.28em] font-bold text-[var(--ebg-gold)]">Our Services</div>
                        <h2 className="font-serif text-3xl md:text-5xl mt-3 leading-[1.05]">Everything real estate, <em className="not-italic text-[var(--ebg-gold)]">under one roof.</em></h2>
                    </div>
                    <Link to="/services" data-testid="home-services-cta" className="inline-flex items-center gap-2 bg-[var(--ebg-gold)] text-black px-6 py-3 text-[11px] uppercase tracking-[0.28em] font-bold hover:bg-white transition-colors">
                        Explore All Services <ArrowRight size={12}/>
                    </Link>
                </div>
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-px bg-white/10 border border-white/10">
                    {PRIMARY_SERVICES.map((s) => (
                        <Link key={s.slug} to={`/services/${s.slug}`} data-testid={`home-service-${s.slug}`}
                            className="group bg-[#0a0d18] p-5 md:p-6 hover:bg-white/[0.04] transition-colors flex flex-col">
                            <div className="flex items-start justify-between">
                                <span className="w-10 h-10 rounded-full border border-[var(--ebg-gold)]/50 text-[var(--ebg-gold)] flex items-center justify-center group-hover:bg-[var(--ebg-gold)] group-hover:text-black transition-colors">
                                    <s.icon size={16} strokeWidth={1.8}/>
                                </span>
                                <ArrowUpRight size={15} className="text-white/30 group-hover:text-[var(--ebg-gold)] transition-colors"/>
                            </div>
                            <div className="font-serif text-lg mt-4 leading-tight">{s.t}</div>
                            <p className="text-white/55 text-[12.5px] mt-1.5 leading-relaxed">{s.short}</p>
                        </Link>
                    ))}
                </div>
            </div>
        </section>
    );
}
